import React from "react";
import LegalLayout from "../components/LegalLayout";

const Section = ({ title, children }) => (
  <div data-testid={`cookies-section-${title.toLowerCase().replace(/\s/g, "-")}`}>
    <h2 className="font-heading text-white text-2xl md:text-3xl uppercase tracking-[0.05em] mb-4">
      {title}
    </h2>
    <div className="space-y-3 text-white/85">{children}</div>
  </div>
);

const CookiePolicy = () => {
  return (
    <LegalLayout
      eyebrow="Legal — Cookies"
      title="Política de Cookies"
      testId="cookie-policy-page"
    >
      <p>
        Esta Política de Cookies explica o que são cookies, como são utilizados no website{" "}
        <strong className="text-white">Miguel Faria Photography</strong> e de que forma podes gerir as
        tuas preferências, em conformidade com a Diretiva ePrivacy e o RGPD.
      </p>

      <Section title="O Que São Cookies">
        <p>
          Os cookies são pequenos ficheiros de texto que são guardados no teu dispositivo
          (computador, tablet ou telemóvel) quando visitas um site. Servem para garantir o
          funcionamento correto da página, recordar preferências e, no caso dos cookies
          analíticos, ajudar-nos a perceber como os visitantes interagem com o conteúdo.
        </p>
      </Section>

      <Section title="Tipos de Cookies Utilizados">
        <div className="border border-white/15 p-6 md:p-8">
          <div className="font-heading text-[#c0392b] tracking-[0.3em] text-xs uppercase mb-2">
            Cookies Essenciais
          </div>
          <p className="text-white/85">
            Necessários ao funcionamento básico do website. Permitem, por exemplo, manter o
            registo da tua escolha sobre o aviso de cookies e assegurar a navegação segura.
            Estes cookies <strong className="text-white">não podem ser desativados</strong> sem afetar
            a experiência do site.
          </p>
        </div>
        <div className="border border-white/15 p-6 md:p-8 mt-4">
          <div className="font-heading text-[#c0392b] tracking-[0.3em] text-xs uppercase mb-2">
            Cookies Analíticos (Opcionais)
          </div>
          <p className="text-white/85">
            Recolhem informação anónima sobre o comportamento dos visitantes — páginas visitadas,
            tempo de permanência, origem do tráfego — com o objetivo de melhorar a experiência
            geral do site. Apenas são ativados após o teu consentimento explícito através do
            banner de cookies.
          </p>
        </div>
      </Section>

      <Section title="Gestão e Desativação de Cookies">
        <p>
          Podes, a qualquer momento, gerir ou desativar os cookies diretamente nas definições do
          teu browser. Eis as instruções para os browsers mais comuns:
        </p>
        <ul className="list-none space-y-2">
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Chrome</strong>: Definições → Privacidade e segurança → Cookies e outros dados</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Firefox</strong>: Opções → Privacidade e Segurança → Cookies</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Safari</strong>: Preferências → Privacidade → Gerir Dados de Sites</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Edge</strong>: Definições → Cookies e permissões do site</span></li>
        </ul>
        <p>
          Nota que a desativação de cookies essenciais pode comprometer o funcionamento
          adequado do website.
        </p>
      </Section>

      <Section title="Retirar Consentimento">
        <p>
          Para alterar a tua escolha após a aceitação inicial, basta limpar os cookies do site
          nas definições do browser. Na próxima visita, o banner de cookies voltará a aparecer
          e poderás registar uma nova preferência.
        </p>
      </Section>

      <Section title="Contacto">
        <p>
          Para qualquer dúvida sobre esta Política de Cookies, contacta-nos via Instagram{" "}
          <a
            href="https://www.instagram.com/miguelfaria.photo/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#c0392b] hover:text-white underline underline-offset-4 transition-colors"
          >
            @miguelfaria.photo
          </a>{" "}
          ou através do formulário de contacto no site.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default CookiePolicy;
